import type { Sport } from '#src/__generated__/globalTypes.ts';

import type { ConversionCreditWithAmounts } from './useConversionCredits.tsx';
import { useConversionCredits } from './useConversionCredits.tsx';

export const useConversionCredit = (
  sport?: Sport
): ConversionCreditWithAmounts | undefined => {
  const { conversionCredits } = useConversionCredits({
    sport,
  });

  return conversionCredits?.[0];
};
